import API, { defaultHeaders } from '@/api';

const buildUrl = (payload = {}) => {

  let url = `${API}/panel/invitations?`;

  // Pagination
  if (payload.pagination === false) {
    url += `pagination=0`;
  }
  else {
    url += `page=${payload.page}`;
  }

  // Search / Query
  if (payload.query && typeof query === 'string') {
    url += `&query=${payload.query}`;
  }
  else if (payload.query && typeof payload.query === 'object') {
    const queryString = Object
      .keys(payload.query)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload.query[key])}`)
      .join('&')
    ;

    url += `&query=${queryString}`;
  }

  // User
  if (payload.userId) {
    url += `&userId=${payload.userId}`;
  }

  return url;
};

const fetchListing = (payload = { page: 1, query: null, pagination: true, userId: false }) => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(buildUrl(payload), { headers });
};

export default fetchListing;
